<template>
  <div>
    <Row type="flex" justify="space-between">
      <Col>
        <RadioGroup v-model="query.type" @on-change="changeResourceType">
          <Radio label="0">全部资源</Radio>
          <Radio label="1">我录入的资源</Radio>
          <Radio label="2" v-if="$store.state.user.role == '系统管理员'">
            待审核黑名单的资源
          </Radio>
          <Radio label="3">黑名单的资源</Radio>
          <Radio label="4">回收箱的资源</Radio>
          <Radio label="5">失信箱的资源</Radio>
        </RadioGroup>
      </Col>
      <Col>
        <Button type="success" icon="md-add" @click="addResource">
          添加资源
        </Button>
      </Col>
    </Row>
    <Row class="margin-top-10" type="flex" :gutter="16">
      <Col class="query-item">
        <Input v-model="query.companyName" placeholder="公司名称" />
      </Col>
      <Col class="query-item">
        <Input v-model="query.groupType" placeholder="组织类型" />
      </Col>
      <!-- <Col class="query-item">
        <Input v-model="query.collectType" placeholder="采集类型" />
      </Col>
      <Col class="query-item">
        <Input v-model="query.markType" placeholder="标注类型" />
      </Col> -->
      <Col class="query-item">
        <Input v-model="query.address" placeholder="地址" />
      </Col>
      <Col class="query-item">
        <Input v-model="query.region" placeholder="项目区域" />
      </Col>
      <Col class="query-item">
        <Input v-model="query.ability" placeholder="能力" />
      </Col>
      <Col class="query-item">
        <Input v-model="query.keyword" placeholder="全文模糊搜索关键字" />
      </Col>
      <Col class="query-item">
        <!-- <Select
          v-model="query.resourceType"
          style="width: 120px"
          placeholder="资源类型"
        >
          <Option value="">无</Option>
          <Option value="采集">采集</Option>
          <Option value="标注">标注</Option>
          <Option value="采集与标注">采集和标注</Option>
        </Select> -->

        <Cascader
          :data="resourceTypeData"
          v-model="curResourceTypeIds"
          clearable
          change-on-select
          placeholder="资源类型"
          @on-change="resourceTypeChange"
        ></Cascader>
      </Col>
      <Col class="query-item">
        <Select
          v-model="query.providerLevel"
          style="width: 120px"
          placeholder="资源方等级"
        >
          <Option value="">无</Option>
          <Option value="优选">优选</Option>
          <Option value="一般">一般</Option>
          <Option value="登记备用">登记备用</Option>
        </Select>
      </Col>
      <Col class="query-item">
        <Button type="info" icon="md-query" @click="search()">筛选</Button>
      </Col>
    </Row>
    <div class="margin-top-10">
      <Card>
        <Table
          :data="resourceList"
          :columns="resourceCloumn"
          :loading="loading"
          @on-sort-change="sortChange"
          @on-row-dblclick="showDetail"
        >
          <template slot-scope="{ row }" slot="record">
            <Poptip placement="left" :transfer="true">
              <Button type="text">查看</Button>
              <div class="api" slot="content">
                <table v-if="row.records && row.records.length > 0">
                  <thead>
                    <tr>
                      <th>时间</th>
                      <th>修改人</th>
                      <th>修改内容</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in row.records" :key="index">
                      <td>{{ item.time }}</td>
                      <td>{{ item.user }}</td>
                      <td>{{ item.content }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Poptip>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Dropdown trigger="click" :transfer="true">
              <Button type="primary">
                操作列表
                <Icon type="ios-arrow-down"></Icon>
              </Button>

              <DropdownMenu slot="list">
                <DropdownItem>
                  <Button type="info" @click="showDetail(row)">查看</Button>
                </DropdownItem>
                <!--   <DropdownItem>
                  <Button type="info" @click="addProject(row)">添加项目</Button>
                </DropdownItem> -->
                <DropdownItem>
                  <Button type="primary" @click="update(row)">更新</Button>
                </DropdownItem>
                <DropdownItem>
                  <Button
                    v-if="row.blackListType == 0"
                    type="error"
                    @click="setBlackList(row, 1)"
                  >
                    放入黑名单
                  </Button>
                </DropdownItem>
                <DropdownItem v-if="row.blackListType == 1">
                  <Button type="error" @click="setBlackList(row, 2)">
                    确认黑名单
                  </Button>
                </DropdownItem>
                <DropdownItem
                  v-if="row.blackListType == 2 || row.blackListType == 1"
                >
                  <Button type="error" @click="setBlackList(row, 0)">
                    移出黑名单
                  </Button>
                </DropdownItem>
                <DropdownItem>
                  <Button
                    type="error"
                    v-if="
                      row.entryUserId == $store.state.user.userId ||
                        $store.state.user.role == '系统管理员'
                    "
                    @click="deleteRes(row)"
                  >
                    删除
                  </Button>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
        </Table>
        <Page
          class="margin-top-10"
          :total="resourceCount"
          @on-change="changePage"
          :current="query.page"
          :page-size="query.size"
          show-total
          show-elevator
        />
      </Card>
    </div>
    <Modal
      v-model="addResourceModal"
      :width="900"
      :scrollable="true"
      :title="addResourceModalTitle"
      :mask="true"
      :mask-closable="false"
    >
      <addResource
        ref="addResourceCom"
        :resourceTypeList="resourceTypeData"
      ></addResource>
      <div slot="footer">
        <Button type="primary" long :loading="addLoading" @click="saveResource">
          保存
        </Button>
      </div>
    </Modal>
    <Modal
      v-model="resourceDetailModal"
      title="资源详情"
      :mask="true"
      :mask-closable="true"
      footer-hide
      :width="800"
    >
      <resourceDetail ref="resourceDetail"></resourceDetail>
    </Modal>
    <Modal
      v-model="addProjectModal"
      :width="800"
      :scrollable="true"
      title="添加项目信息"
      :mask="true"
      :mask-closable="false"
    >
      <addProject ref="projectInfo"></addProject>
      <div slot="footer">
        <Button type="primary" long :loading="addLoading" @click="saveRProject">
          保存
        </Button>
      </div>
    </Modal>

    <Modal
      :title="setBlackListModalTitle"
      v-model="setBlackListModal"
      :width="600"
      :scrollable="true"
      :mask="true"
      :mask-closable="false"
    >
      <Row type="flex" justify="center" align="middle" class="query-item">
        <Col span="4">
          黑名单类型:
        </Col>
        <Col span="20">
          <Select v-model="blackType" style="width:200px">
            <Option :value="0">黑名单</Option>
            <Option :value="1">回收箱</Option>
            <Option :value="2">失信箱</Option>
          </Select>
        </Col>
      </Row>
      <Row type="flex" justify="center" align="middle">
        <Col span="4">
          请输入原因:
        </Col>
        <Col span="20">
          <Input type="textarea" :rows="4" v-model="blackListReason"></Input>
        </Col>
      </Row>
      <div slot="footer">
        <Button
          type="primary"
          long
          :loading="addLoading"
          @click="saveBlackList"
        >
          保存
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import expandRow from "./expand.vue";
import addProject from "./addProject";
import addResource from "./addResource";
import resource from "@/api/resource.js";
import resourceDetail from "./resourceDetail";
import project from "@/api/project.js";
import { toTree, findPathbyId, getChildrenIds } from "@/libs/tools";
export default {
  components: {
    addProject,
    addResource,
    resourceDetail,
    expandRow,
  },
  data() {
    return {
      loading: false,
      setBlackListModal: false,
      setBlackListModalTitle: "",
      blackListReason: "",
      blackListType: 0,
      blackType: 0,
      selectRow: null,
      query: {
        type: "0",
        companyName: "",
        // collectType: "",
        // markType: "",
        address: "",
        ability: "",
        resourceType: "",
        providerLevel: "",
        page: 1,
        size: 20,
      },
      curResourceTypeIds: [],
      resourceTypeData: [],
      resourceId: "",
      addResourceModalTitle: "",
      addResourceModal: false,
      resourceDetailModal: false,
      addProjectModal: false,
      addLoading: false,
      resourceList: [],
      resourceCount: 0,
      resourceCloumn: [
        // {
        //   type: "expand",
        //   width: 50,
        //   render: (h, params) => {
        //     return h(expandRow, {
        //       props: {
        //         id: params.row.id
        //       }
        //     });
        //   }
        // },
        {
          title: "公司(团队)名称",
          key: "companyName",
          // align: "center",
          minWidth: 120,
        },
        // {
        //   title: "组织类型",
        //   key: "groupType",
        //   align: "center",
        // },
        // {
        //   title: "采集类型",
        //   key: "collectType",
        //   align: "center",
        // },
        // {
        //   title: "标注类型",
        //   key: "markType",
        //   align: "center",
        // },

        {
          title: "地址",
          key: "address",
          // align: "center",
        },
        {
          title: "能力",
          key: "ability",
          align: "center",
        },
        // {
        //   title: "资源类型",
        //   key: "resourceType",
        //   align: "center",
        //   render: function(h, params) {
        //     let str = "";
        //     switch (this.row.resourceType) {
        //       case 0:
        //         str = "采集";
        //         break;
        //       case 1:
        //         str = "标注";
        //         break;
        //       case 2:
        //         str = "采集与标注";
        //     }
        //     return h("div", str);
        //   },
        // },
        {
          title: "资源方等级",
          key: "providerLevel",
          align: "center",
          width: 110,
          render: function(h, params) {
            let str = "";
            switch (this.row.providerLevel) {
              case 0:
                str = "优选";
                break;
              case 1:
                str = "一般";
                break;
              case 2:
                str = "登记备用";
            }
            return h("div", str);
          },
        },

        {
          title: "合作次数",
          key: "cooperationCount",
          align: "center",
          sortable: "custom",
          width: 110,
        },
        {
          title: "评估次数",
          key: "assessmentCount",
          align: "center",
          sortable: "custom",
          width: 110,
        },
        {
          title: "录入时间",
          key: "inTime",
          // align: "center",
          sortable: "custom",
          //width: 120,
          render: function(h, params) {
            if (this.row.inTime) {
              //时区处理
              var localDate = new Date(this.row.inTime);
              var localTime = localDate.getTime();
              var localOffset = localDate.getTimezoneOffset() * 60 * 1000;

              return h(
                "div",
                new Date(localTime + localOffset).toLocaleString()
              );
            }
          },
        },
        {
          title: "修改记录",
          align: "center",
          slot: "record",
          width: 100,
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width: 130,
        },
      ],
    };
  },
  methods: {
    getResourceType() {
      let _this = this;
      resource
        .listResourceType({})
        .then((res) => {
          //_this.data = res.data;
          _this.resourceTypeData = toTree(res.data);
          //_this.data.unshift({ id: "", name: "--顶级--" });
        })
        .catch((err) => {
          if (err.response.data.message)
            _this.$Message.error(err.response.data.message);
          else _this.$Message.error(JSON.stringify(err.response.data));
        });
    },
    changePage(p) {
      this.query.page = p;
      this.getData();
    },
    addResource() {
      this.addResourceModal = true;
      this.addResourceModalTitle = "新增资源";
      this.$refs.addResourceCom.setData({
        cooperations: [],
        assessments: [],
        contacts: [],
        resourceTypeM2Ms: [{}],
        partyAProjects: [],
      });
    },
    saveResource() {
      let _this = this;
      this.$refs.addResourceCom.getData((data) => {
        if (
          !data.resourceTypeM2Ms ||
          !data.resourceTypeM2Ms.length ||
          data.resourceTypeM2Ms.some((x) => {
            return !x.resourceTypeId;
          })
        ) {
          _this.$Message.error(
            "资源类型是必选项，如果没有内容，请删除多余的选择框。",
            5
          );
          return false;
        }

        let partyAIsNull = data.partyAProjects.some((p) => {
          return !p.name && p.status == 0;
        });
        if (partyAIsNull) {
          _this.$Message.error(
            "甲方项目必填，输入框不能为空，如果没有内容，请删除输入框。",
            5
          );
          return false;
        }

        let coopIsNull = data.cooperations.some((coop) => {
          return !coop.name && coop.status == 0;
        });
        if (coopIsNull) {
          _this.$Message.error(
            "参与公司合作项目，输入框不能为空，如果没有内容，请删除输入框。",
            5
          );
          return false;
        }

        let assmIsNull = data.assessments.some((assm) => {
          return !assm.name && assm.status == 0;
        });
        if (assmIsNull) {
          _this.$Message.error(
            "参与公司评估项目，输入框不能为空，如果没有内容，请删除输入框。",
            5
          );
          return false;
        }

        this.addLoading = true;
        if (data.id) {
          resource
            .updateResource(data)
            .then((res) => {
              _this.getData();
              _this.$Message.success("保存成功");
              _this.addLoading = false;
              _this.addResourceModal = false;
            })
            .catch((err) => {
              _this.addLoading = false;
              if (err.response.data.message)
                _this.$Message.error(err.response.data.message);
              else _this.$Message.error(JSON.stringify(err.response.data));
            });
        } else {
          resource
            .addResource(data)
            .then((res) => {
              _this.getData();
              _this.$Message.success("保存成功");
              _this.addLoading = false;
              _this.addResourceModal = false;

              _this.$refs.addResourceCom.clearData();
            })
            .catch((err) => {
              _this.addLoading = false;
              if (err.response.data.message)
                _this.$Message.error(err.response.data.message);
              else _this.$Message.error(JSON.stringify(err.response.data));
            });
        }
      });
    },
    saveRProject() {
      let _this = this;
      var data = this.$refs.projectInfo.getData();
      data.resourceId = this.resourceId;
      this.addLoading = true;

      if (data.id) {
        project
          .updateRProject(data)
          .then((res) => {
            _this.getData();
            _this.$Message.success("保存成功");
            _this.addLoading = false;
            _this.addProjectModal = false;
          })
          .catch((err) => {
            _this.$Message.error(err.response.data.message);
            _this.addLoading = false;
          });
      } else {
        project
          .addRProject(data)
          .then((res) => {
            _this.getData();
            _this.$Message.success("保存成功");
            _this.addLoading = false;
            _this.addProjectModal = false;
          })
          .catch((err) => {
            _this.$Message.error(err.response.data.message);
            _this.addLoading = false;
          });
      }
    },
    getData() {
      let _this = this;
      this.loading = true;
      resource
        .resourceList(this.query)
        .then((res) => {
          _this.loading = false;
          if (res.data) {
            _this.resourceList = res.data.data;
            _this.resourceCount = res.data.count;
          }
        })
        .catch((err) => {
          _this.loading = false;
          if (err.response.data.message)
            _this.$Message.error(err.response.data.message);
          else _this.$Message.error(JSON.stringify(err.response.data));
        });
    },
    showDetail(row) {
      if (!row || !row.id) {
        this.$Message.error("请刷新页面重试");
        return;
      }
      let _this = this;
      _this.resourceDetailModal = true;
      let res = JSON.parse(JSON.stringify(row)); //{ ...row };

      if (res.resourceTypeM2Ms && res.resourceTypeM2Ms.length) {
        res.resourceTypeM2Ms.forEach((item) => {
          if (item.resourceTypeId) {
            let parents = findPathbyId(
              _this.resourceTypeData,
              item.resourceTypeId
            );
            if (parents && parents.length > 0)
              item.resourceTypeNames = parents.map((x) => x.name).join(" / ");
          }
        });
      }
      _this.$refs.resourceDetail.setData(res);
    },
    update(row) {
      if (!row || !row.id) {
        this.$Message.error("请刷新页面重试");
        return;
      }
      this.addResourceModal = true;
      this.addResourceModalTitle = "更新资源";
      let res = JSON.parse(JSON.stringify(row)); //{ ...row };

      let _this = this;
      if (res.resourceTypeM2Ms && res.resourceTypeM2Ms.length) {
        res.resourceTypeM2Ms.forEach((item) => {
          if (item.resourceTypeId) {
            let parents = findPathbyId(
              _this.resourceTypeData,
              item.resourceTypeId
            );
            if (parents && parents.length > 0)
              item.resourceTypeIds = parents.map((x) => x.id);
          }
        });
      } else {
        res.resourceTypeM2Ms = [{}];
      }

      this.$refs.addResourceCom.setData(res);
    },
    changeResourceType(e) {
      this.query.page = 1;
      this.getData();
    },
    addProject(row) {
      this.resourceId = row.id;
      this.addProjectModal = true;
    },
    deleteRes(row) {
      let _this = this;
      this.$Modal.confirm({
        title: "是否删除该资源？",
        onOk: () => {
          resource
            .deleteResource({
              id: row.id,
            })
            .then((res) => {
              _this.getData();
              _this.$Message.success("删除成功！");
            })
            .catch((err) => {
              _this.$Message.error(err.response.data.message);
            });
        },
      });
    },
    search() {
      this.query.page = 1;
      this.getData();
    },
    setBlackList(row, blackListType) {
      //console.log(row);
      this.blackListReason = row.blackListReason;
      this.selectRow = row;
      this.selectRow.blackListType = blackListType;
      var content = "";
      if (blackListType == 0) {
        content = "是否移出黑名单?";
      } else if (blackListType == 1) {
        content = "是否放入黑名单?";
      } else if (blackListType == 2) {
        content = "是否确认黑名单?";
      }
      this.setBlackListModal = true;
      this.setBlackListModalTitle = content;
    },
    saveBlackList() {
      let _this = this;
      //console.log(this.selectRow);

      resource
        .setBlackList({
          id: this.selectRow.id,
          blackListType: this.selectRow.blackListType,
          blackType: this.blackType,
          blackListReason: this.blackListReason,
        })
        .then((res) => {
          this.blackListReason = "";
          this.setBlackListModal = false;
          _this.$Message.success("设置成功！");
          _this.getData();
        })
        .catch((err) => {
          if (err.response.data.message)
            _this.$Message.error(err.response.data.message);
          else _this.$Message.error(JSON.stringify(err.response.data));
        });
    },
    resourceTypeChange(values, selectedDatas) {
      this.query.resourceTypeIds = [];
      if (values && values.length > 0) {
        let resourceTypeId = values[values.length - 1];
        let ids = getChildrenIds(this.resourceTypeData, resourceTypeId, []);
        ids.push(resourceTypeId);
        this.query.resourceTypeIds = ids.join(",");
      }
    },
    sortChange(e) {
      //console.log(column, key, order);
      this.query.sort = e.key;
      this.query.order = e.order;
      this.query.page = 1;
      this.getData();
    },
  },
  mounted() {
    this.getResourceType();
    this.getData();
  },
};
</script>
<style>
.query-item {
  margin-bottom: 10px;
}
</style>
